<template>
  <ul :class="variant === 'modal' ? 'space-y-6 pt-4' : 'space-y-4'">
    <li v-for="({ label, text, thumbnail, url }, i) in data" :key="i">
      <component
        :is="url ? BaseLink : 'div'"
        class="group flex items-start"
        :class="variant === 'modal' ? 'gap-6' : 'gap-4'"
        :to="url"
      >
        <base-picture
          v-if="showThumbnails && thumbnail"
          :alt="label"
          class="aspect-square w-full shrink-0"
          fit="contain"
          :height="variant === 'modal' ? 60 : 52"
          :src="thumbnail"
          :style="`max-width: ${variant === 'modal' ? 3.75 : 3.25}rem`"
          :width="variant === 'modal' ? 60 : 52"
        />
        <div class="grow space-y-1">
          <p v-if="label" class="fw-bold title-5" :class="{ 'group-hover:underlined': url }">
            <base-interpolator :content="formatBarcodeText(label)">
              <template #product-link="{ args: [pid] }">
                <vf-link
                  data-product-barcode-link
                  :to="getBarcodeLink()"
                >
                  {{ pid }}
                </vf-link>
              </template>
            </base-interpolator>
          </p>
          <div
            v-if="text"
            class="ws-pre-wrap subtitle-4"
            :class="{ 'group-hover:underlined': url && !label }"
          >
            <base-interpolator :content="formatBarcodeText(text)">
              <template #product-link="{ args: [pid] }">
                <vf-link
                  data-product-barcode-link
                  :to="getBarcodeLink()"
                >
                  {{ pid }}
                </vf-link>
              </template>
            </base-interpolator>
          </div>
        </div>
      </component>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'
import { BaseLink } from '#components'

const props = defineProps<{
  data: ProductDetailContent[]
  title?: string
  variant?: 'modal'
}>()

const { productId } = usePdp()
const { formatBarcodeText, getBarcodeLink } = useBarcode(productId.value)
const showThumbnails = props.data?.some(({ thumbnail }) => !!thumbnail)
</script>
